import { useCallback } from "react"
import { toast } from "sonner"
import openAuth from "./openAuth"
import type { SocialProvider } from "./model"
import { useConnectOauthMutation } from "./api"
import { withRefreshLock } from "./refreshLock"
import { useTokenRefreshMutation } from "@/base/baseApi"

export default () => {
  const [connect, { isLoading: isConnecting }] = useConnectOauthMutation()
  const [tokenRefresh] = useTokenRefreshMutation()

  const handleConnect = useCallback(
    (provider: SocialProvider) => {
      openAuth(
        async () => {
          const { authUrl } = await connect({ provider }).unwrap()

          return authUrl
        },
        async (result) => {
          switch (result.result) {
            case "success":
              // Under the lock like every other write of the shared token: this one arrives from
              // a popup and can land while another tab is mid-refresh.
              await withRefreshLock(() =>
                tokenRefresh(result.refreshToken).unwrap(),
              )

              return
            case "cancelled":
              return
            case "error":
              toast.error(result.error || "Authentication Failed.")

              return
          }
        },
      )
    },
    [connect, tokenRefresh],
  )

  return { handleConnect, isConnecting }
}
